exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".receive-settle .create-settle[data-v-a96a9a82]{margin:20px}.receive-settle .select-conditions[data-v-a96a9a82]{width:1800px;height:220px;padding:20px;background:#f2f3f5}.receive-settle .select-conditions-row[data-v-a96a9a82]{width:1000px;height:40px;margin:20px 0}.receive-settle .receive-settle-table[data-v-a96a9a82]{margin-top:20px}.receive-settle .receive-settle-table .receive-settle-pagination[data-v-a96a9a82]{margin-top:40px;height:40px;text-align:right}\n", ""]);

// exports
